var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightBulbBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.647,
    height: 38.706,
    viewBox: "0 0 27.647 38.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(85 48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(-85 -48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M12.922,5.5a.922.922,0,0,0,0,1.843,3.624,3.624,0,0,1,3.62,3.62.922.922,0,1,0,1.843,0A5.47,5.47,0,0,0,12.922,5.5Z",
    transform: "translate(0.902 2.794)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M18.823,1A13.8,13.8,0,0,0,7.348,22.5a1.7,1.7,0,0,0,.147.249c3.364,4.8,3.955,6.322,3.955,7.741V36.02a1.844,1.844,0,0,0,1.843,1.843H16.98a1.851,1.851,0,0,0,3.152,1.309,1.938,1.938,0,0,0,.535-1.309h3.686A1.844,1.844,0,0,0,26.2,36.02V30.49c0-1.441.588-2.967,3.93-7.739A13.8,13.8,0,0,0,18.823,1ZM22.51,34.176H15.137V32.333H22.51Zm4.6-13.541c-2.7,3.858-3.95,6.062-4.4,8.012H20.667V24.961a1.843,1.843,0,0,0-3.686,0v3.686H14.929c-.442-1.9-1.655-4.055-4.25-7.778a1.973,1.973,0,0,0-.142-.238,10.137,10.137,0,1,1,16.572,0Z",
    transform: "translate(-5 -1)",
    fill: "#1e1e1e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulbBlack);
export default __webpack_public_path__ + "static/media/light-bulb-black.451dd5a064c349d49723c74422fa5b52.svg";
export { ForwardRef as ReactComponent };